module.exports = __webpack_public_path__ + "static/img/icon_downloadcode@2x.88ca0ff8.png";